
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const Footer: React.FC = () => {
  const navigate = useNavigate();

  return (
    <footer className="bg-slate-900/95 backdrop-blur-xl border-t border-slate-700/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <div className="flex items-center space-x-3 mb-6">
              <img src="/lovable-uploads/d981c4c2-888d-4322-9d83-e527475f379f.png" alt="Flamingo Logo" className="h-8 w-auto" />
            </div>
            <p className="text-slate-400 leading-relaxed">
              The AI-powered rental platform revolutionizing how people find their perfect home in Louisville, Kentucky.
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-6 flex items-center">
              <ArrowRight className="w-4 h-4 mr-2 text-primary" />
              For Renters
            </h4>
            <ul className="space-y-3 text-slate-400">
              <li>
                <button onClick={() => navigate('/signup')} className="hover:text-primary transition-colors duration-200 hover:translate-x-1 transform">
                  AI Property Discovery
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/signup')} className="hover:text-primary transition-colors duration-200 hover:translate-x-1 transform">
                  Interactive Map
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/signup')} className="hover:text-primary transition-colors duration-200 hover:translate-x-1 transform">
                  Smart Budget Tool
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/signup')} className="hover:text-primary transition-colors duration-200 hover:translate-x-1 transform">
                  Rental Guidance
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-6 flex items-center">
              <ArrowRight className="w-4 h-4 mr-2 text-primary" />
              For Landlords
            </h4>
            <ul className="space-y-3 text-slate-400">
              <li>
                <button onClick={() => navigate('/signup')} className="hover:text-primary transition-colors duration-200 hover:translate-x-1 transform">
                  Smart Listings
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/signup')} className="hover:text-primary transition-colors duration-200 hover:translate-x-1 transform">
                  AI Tenant Matching
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/signup')} className="hover:text-primary transition-colors duration-200 hover:translate-x-1 transform">
                  Portfolio Analytics
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/signup')} className="hover:text-primary transition-colors duration-200 hover:translate-x-1 transform">
                  Revenue Optimization
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-6 flex items-center">
              <ArrowRight className="w-4 h-4 mr-2 text-primary" />
              Platform
            </h4>
            <ul className="space-y-3 text-slate-400">
              <li>
                <button onClick={() => navigate('/signup')} className="hover:text-primary transition-colors duration-200 hover:translate-x-1 transform">
                  AI Support Center
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/signup')} className="hover:text-primary transition-colors duration-200 hover:translate-x-1 transform">
                  Connect With Us
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/privacy')} className="hover:text-primary transition-colors duration-200 hover:translate-x-1 transform">
                  Privacy & Security
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/terms')} className="hover:text-primary transition-colors duration-200 hover:translate-x-1 transform">
                  Terms of Service
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-700/50 mt-12 pt-8">
          <div className="flex flex-col lg:flex-row justify-between items-center space-y-4 lg:space-y-0">
            <p className="text-slate-500 text-center lg:text-left">
              © 2025 Flamingo AI. All rights reserved. The future of intelligent rental experiences.
            </p>
            <div className="flex items-center space-x-6">
              <button onClick={() => navigate('/privacy')} className="text-slate-500 hover:text-primary transition-colors duration-200 text-sm">
                Privacy
              </button>
              <button onClick={() => navigate('/terms')} className="text-slate-500 hover:text-primary transition-colors duration-200 text-sm">
                Terms
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
